import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NetValueHigherThan15000Warning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.payment-method.net-value-too-high-for-cash.15000');
    }
}